// Public key access token using MapTiler: https://cloud.maptiler.com/maps/pastel/maplibre-gl-js
export const MAPTILER_API_TOKEN = 'z2Fd01Dm9HxpPEcYjrj6' // pragma: allowlist secret
